"use client";
import React from "react";
import style from "./Categories.module.scss";
import { MagneticChipButton } from "@/components/common/Buttons/MagneticChipButton/MagneticChipButton";
import { PixelEvents } from "@/components/Pixel/PixelManager";

export const Categories = ({ data: fewerCategories, title = null }) => {
  if (!fewerCategories || fewerCategories.length === 0) return null;

  const handleCategoryClick = (categoryTitle: string) => {
    PixelEvents.filterBlogByCategory(categoryTitle);
  };

  return (
    <section className={style.sectionContainer}>
      <div className="container-blog">
        <h2>{title}</h2>
        <ul>
          {fewerCategories.map((category, index) => (
            <li key={index} onClick={() => handleCategoryClick(category.attributes.title)}>
              <MagneticChipButton
                label={category.attributes.title}
                variant="category"
                href={`/blog/category/${category.attributes.slug}`}
                magneticStrength={0.0}
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
